<template>
    <div class="confirmContainer">
        <div v-if = "congratulationsText">
            <h2 class="mt-20 mb-15">Congratulations</h2>
            <p v-if="escrowBalance < 500000 && isFirstTime">
                Dear {{getName}}, we have received &#x20B9;{{escrowBalance / 100 | localeAmount}} in your virtual account.
                Minimum investment amount is &#x20B9;5000. Please transfer the difference to continue with the investment journey.
            </p>
            <p v-else-if="escrowBalance < selectedPortfolio.expectedInvestmentAmount && isFirstTime">
                Dear {{getName}}, we have received &#x20B9;{{escrowBalance / 100 | localeAmount}} in your virtual account.
                It is less than the investment amount &#x20B9;{{selectedPortfolio.expectedInvestmentAmount/100 | localeAmount}} entered while choosing the plan. If you wish to add more funds, please transfer the difference to your virtual account. Otherwise click "confirm" to continue with the received amount.
            </p>
            <p v-else>
                Dear {{getName}}, an amount of &#x20B9;{{selectedPortfolio.expectedInvestmentAmount/100 | localeAmount}}
                is being invested in our {{selectedPortfolio.planType | capitalize}}
                Plan with an {{selectedPortfolio.riskProfile | capitalize}} risk profile,
                for a tenure of 12 months. Please confirm to continue with this plan or choose another
                plan.
            </p>
        </div>
        <PlanCard v-if="selectedPortfolio && hidePlan" :portfolio="selectedPortfolio"/>

        <div class="dashboard__actions">
            <a v-if = "hideChoosePlan" class="btn btn-link" @click="chooseAnotherPlan">Choose Another Plan</a>
        </div>
        <div v-show = "!isButtonDisabled" class = "buttonContainer">
            <button class="btn_new btn-secondary-new px-5" :disabled="isButtonDisabled" @click="triggerPortfolioPayment">
                Confirm
            </button>
        </div>
        <div v-if = "(escrowBalance/100 >= 5000 && isFirstTime)" class = "buttonContainerReview">
            <button class="buttonReview btn_new btn-secondary-new px-5" @click="reviewPlan">
                Review your plan
            </button>
        </div>
        <planSelectionDialog
        v-if = "showPlanDialog"
        :showPlanDialog="showPlanDialog"
        :selectedPortfolio="selectedPortfolio"
        @closeDialog = "closeDialog"
        />
    </div>
</template>

<script>
import PlanCard from '../common/planCard/planCard.vue'
import LenderService from '@/services/lenderService'
import OnboardingService from '@/services/lenderOnboardingService.js'
import planSelectionDialog from '../common/planSelectionDialog.vue'

export default {
    name: 'PortfolioConfirm',
    props: {
        selectedPortfolio: Object,
        isCreatePortfolio: Boolean,
        isEditPortfolio: Boolean,
        isFirstTime: Boolean,
        escrowBalance: Number,
        hideChoosePlan: Boolean,
        hidePlan: Boolean,
        congratulationsText: Boolean,
        accountInfo: Object
    },
    components: {
        PlanCard,
        planSelectionDialog
    },
    filters: {
        capitalize (value) {
            return value[0].toUpperCase() + value.slice(1)
        }
    },
    computed: {
        getName () {
            return this.$store.state.userName || this.$store.state.onBoarding.Name
        },
        isButtonDisabled () {
            console.log('check', (this.selectedPortfolio?.expectedInvestmentAmount / 100) > this.escrowBalance)
            if (this.isFirstTime && this.escrowBalance < 500000) {
                return true
            } else if (this.isFirstTime && (this.selectedPortfolio?.expectedInvestmentAmount > this.escrowBalance || this.selectedPortfolio?.expectedInvestmentAmount < 500000)) {
                console.log('disableding')
                return true
            }
            return false
        }
    },
    data () {
        return {
            showPlanDialog: false
        }
    },
    methods: {
        async savePortfolio () {
            const portfolio = { ...this.selectedPortfolio }
            portfolio.expectedInvestmentAmount /= 100
            if (this.selectedPortfolio.investmentType !== 'manual') {
                await OnboardingService.createPortfolio(portfolio).then(async (res) => {
                    if (res.status === 200) {
                        if (res.data?.portfolioId) {
                            const payload = {
                                portfolioId: res.data.portfolioId
                            }
                            await this.payPortfolio(payload)
                        } else {
                            this.$emit('success')
                        }
                    } else if (res.status === 402) {
                        this.$emit('insufficientFunds')
                    } else if (res.status === 409) {
                    }
                    this.$store.commit('isNotLoading')
                })
            }
        },
        async editPortfolioAmount () {
            const payload = {
                portfolioId: this.selectedPortfolio.portfolioId,
                investmentAmount: this.escrowBalance
            }
            await LenderService.editPortfolio(payload).then(async (res) => {
                if (res.status === 200) {
                    await this.payPortfolio(payload)
                }
            })
            this.$store.commit('isNotLoading')
        },
        async triggerPortfolioPayment () {
            this.facebookConversion()
            this.$store.commit('isLoading')
            // eslint-disable-next-line no-unused-vars
            if (this.isCreatePortfolio) {
                await this.savePortfolio()
            } else if (this.isFirstTime && this.escrowBalance >= 500000 && this.escrowBalance < this.selectedPortfolio.expectedInvestmentAmount) {
                this.editPortfolioAmount()
            } else {
                const payload = {
                    portfolioId: this.selectedPortfolio.portfolioId,
                    investmentAmount: this.selectedPortfolio.expectedInvestmentAmount
                }
                await this.payPortfolio(payload)
            }
        },
        facebookConversion () {
            const payload = {}
            payload.EventName = 'purchase'
            OnboardingService.facebookConversionAPI(payload).then(async (res) => {})
        },
        async payPortfolio (payload) {
            await LenderService.payInvestmentPortfolio(payload).then((res) => {
                if (res.status === 200) {
                    this.$emit('success')
                } else if (res.status === 402) {
                    this.$emit('insufficientFunds')
                }
                this.$store.commit('isNotLoading')
            })
        },
        chooseAnotherPlan () {
            this.$emit('chooseAnotherPlan')
        },
        reviewPlan () {
            this.showPlanDialog = true
        },
        closeDialog () {
            location.reload()
            this.showPlanDialog = false
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/components/dashboard/dashboard.scss";
.actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.buttonContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.buttonContainerReview {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.buttonReview {
  background: #e0e0e0 !important;
  border-color: #e0e0e0 !important;
  font-size: 16px !important;
  color: #232323 !important;
  font-weight: 600 !important;
}
</style>
